import { Box, Stack, styled } from "@mui/material";
import { DarkModeBackground, ShGreenLightGradient } from "shared/SharedStyles/styleConstants";

export const ResourceElementsBorderRadius = 20;

export const ResourcesWrapperBox = styled(Box)(
    ({ theme }) => ({
        flex: 1,
        height: '100vh', overflow: 'auto',
        background: theme.palette.mode === "light" ? ShGreenLightGradient : DarkModeBackground
    })
);

export const ResourceTitleStack = styled(Stack)(
    ({ theme }) => ({
        flexDirection: 'row',
        alignItems: 'center',
        paddingTop: theme.spacing(2),
        paddingBottom: theme.spacing(2),
        position: 'relative',
        '& .back-button': {
            position: 'absolute',
            top: '50%',
            left: 0,
            transform: 'translate(0%, -50%)'
        }
    })
);

export const ResourceHomeStack = styled(Stack)(
    ({ theme }) => ({
        boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.1)',
        backgroundColor: '#fff',
        padding: theme.spacing(5),
        borderRadius: ResourceElementsBorderRadius,
    })
);